export default __webpack_public_path__ + "assets/images/cc93398ece1f533103362e8035a0198d.svg";